import React from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

const PdpRegionSkeleton = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 414, h: 608 }
    : { w: 930, h: 674 };

  return (
    <div>
      <PlaceholderLoader
        width={width}
        height={height}
        uid="cardSkeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        {mobile ? (
          <>
            <rect y="120" width="413" height="189" rx="5" />
            <rect y="44" width="397" height="14" rx="4" />
            <rect y="64" width="336" height="14" rx="4" />
            <rect y="86" width="300" height="14" rx="4" />
            <rect width="87" height="24" rx="5" />
            <rect x="69" y="342" width="276" height="24" rx="5" />
            <rect x="175" y="390" width="98" height="14" rx="5" />
            <rect x="126" y="390" width="35" height="35" rx="10" />
            <rect x="175" y="407" width="17" height="16" rx="8" />
            <rect x="215" y="407" width="17" height="16" rx="8" />
            <rect x="252" y="407" width="18" height="16" rx="8" />
            <rect x="233" y="407" width="18" height="16" rx="8" />
            <rect x="196" y="407" width="16" height="16" rx="8" />
            <rect x="177" y="512" width="97" height="15" rx="5" />
            <rect x="127" y="512" width="35" height="35" rx="10" />
            <rect x="177" y="529" width="18" height="17" rx="8.5" />
            <rect x="217" y="529" width="17" height="17" rx="8.5" />
            <rect x="254" y="529" width="18" height="17" rx="8.5" />
            <rect x="236" y="529" width="17" height="17" rx="8.5" />
            <rect x="198" y="529" width="17" height="17" rx="8.5" />
            <rect x="177" y="573" width="97" height="15" rx="5" />
            <rect x="127" y="573" width="35" height="35" rx="10" />
            <rect x="177" y="590" width="17" height="17" rx="8.5" />
            <rect x="217" y="590" width="17" height="17" rx="8.5" />
            <rect x="254" y="590" width="18" height="17" rx="8.5" />
            <rect x="235" y="590" width="18" height="17" rx="8.5" />
            <rect x="198" y="590" width="17" height="17" rx="8.5" />
            <rect x="175" y="452" width="98" height="15" rx="5" />
            <rect x="126" y="452" width="35" height="35" rx="10" />
            <rect x="175" y="469" width="17" height="17" rx="8.5" />
            <rect x="215" y="469" width="17" height="17" rx="8.5" />
            <rect x="252" y="469" width="18" height="17" rx="8.5" />
            <rect x="233" y="469" width="18" height="17" rx="8.5" />
            <rect x="196" y="469" width="16" height="17" rx="8" />
          </>
        ) : (
          <>
            <rect y="115" width="930" height="362" rx="5" />
            <rect y="48" width="895" height="19" rx="4" />
            <rect y="74" width="468" height="19" rx="4" />
            <rect width="114" height="31" rx="5" />
            <rect y="507" width="319" height="31" rx="5" />
            <rect x="57" y="562" width="113" height="16" rx="5" />
            <rect y="562" width="40" height="40" rx="10" />
            <rect x="55" y="581" width="20" height="20" rx="10" />
            <rect x="100" y="581" width="20" height="20" rx="10" />
            <rect x="144" y="581" width="20" height="20" rx="10" />
            <rect x="122" y="581" width="20" height="20" rx="10" />
            <rect x="78" y="581" width="20" height="20" rx="10" />
            <rect x="282" y="562" width="113" height="16" rx="5" />
            <rect x="225" y="562" width="40" height="40" rx="10" />
            <rect x="280" y="581" width="20" height="20" rx="10" />
            <rect x="325" y="581" width="20" height="20" rx="10" />
            <rect x="369" y="581" width="20" height="20" rx="10" />
            <rect x="347" y="581" width="20" height="20" rx="10" />
            <rect x="303" y="581" width="20" height="20" rx="10" />
            <rect x="509" y="562" width="113" height="16" rx="5" />
            <rect x="452" y="562" width="40" height="40" rx="10" />
            <rect x="507" y="581" width="20" height="20" rx="10" />
            <rect x="552" y="581" width="20" height="20" rx="10" />
            <rect x="596" y="581" width="20" height="20" rx="10" />
            <rect x="574" y="581" width="20" height="20" rx="10" />
            <rect x="530" y="581" width="20" height="20" rx="10" />
            <rect x="57" y="634" width="113" height="16" rx="5" />
            <rect y="634" width="40" height="40" rx="10" />
            <rect x="55" y="653" width="20" height="20" rx="10" />
            <rect x="100" y="653" width="20" height="20" rx="10" />
            <rect x="144" y="653" width="20" height="20" rx="10" />
            <rect x="122" y="653" width="20" height="20" rx="10" />
            <rect x="78" y="653" width="20" height="20" rx="10" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

export default PdpRegionSkeleton;
